module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    staticClass: "tocol"
  }, [_c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/0_chapter1firstestrangement"
    }
  }, [_vm._v("CHAPTER 1 - FIRST ESTRANGEMENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/1_chapter2atalkingqianyuansword"
    }
  }, [_vm._v("CHAPTER 2 - A TALKING QIAN YUAN SWORD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/2_chapter3washingthemarrow"
    }
  }, [_vm._v("CHAPTER 3 - WASHING THE MARROW")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/3_chapter4whoisthevisitor"
    }
  }, [_vm._v("CHAPTER 4 - WHO IS THE VISITOR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/4_chapter5bittertrainingforthreemonths"
    }
  }, [_vm._v("CHAPTER 5 - BITTER TRAINING FOR THREE MONTHS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/5_chapter6latenightassassination"
    }
  }, [_vm._v("CHAPTER 6 - LATE NIGHT ASSASSINATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/6_chapter7fathersinjury"
    }
  }, [_vm._v("CHAPTER 7 - FATHER'S INJURY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/7_chapter8firstheardofthegateofheavenlysecrets"
    }
  }, [_vm._v("CHAPTER 8 - FIRST HEARD OF THE GATE OF HEAVENLY SECRETS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/8_chapter9master",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9 - MASTER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/9_chapter10thewayofcultivation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10 - THE WAY OF CULTIVATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter11animalfightingring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 - ANIMAL FIGHTING RING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter12primitiveoriginbeast",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 - PRIMITIVE ORIGIN BEAST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter13yefamilymarket",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 - YE FAMILY MARKET")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter14blackbrokensword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14 - BLACK BROKEN SWORD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter15swordtest",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15 - SWORD TEST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter16wanghaiofthewangclan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16 - WANG HAI OF THE WANG CLAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter17breakthroughinbattle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17 - BREAKTHROUGH IN BATTLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter18kill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18 - KILL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter19wangfamilychase",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19 - WANG FAMILY CHASE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter20denseforestbattle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20 - DENSE FOREST BATTLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter21encounteredbinarybeast",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21 - ENCOUNTERED BINARY BEAST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter22xueyaner",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22 - XUEYAN'ER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter23phagocytosis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23 - PHAGOCYTOSIS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter24masteryoftheelementalistsninthlayer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24 - MASTERY OF THE ELEMENTALIST'S NINTH LAYER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter25counterattack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25 - COUNTERATTACK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter26zhanwangjiang",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26 - ZHAN WANG JIANG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter27retreatingwithfullbody",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27 - RETREATING WITH FULL BODY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter28masterteng",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28 - MASTER TENG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter29reenteringthecolosseum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29 - REENTERING THE COLOSSEUM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter30ironbackbluewolf",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30 - IRONBACK BLUE WOLF")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter31winningstreak",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31 - WINNING STREAK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter32blademaster",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32 - BLADEMASTER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter33asensationcausedbyyama",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33 - A SENSATION CAUSED BY YAMA")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter34arrestthemurderer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34 - ARREST THE MURDERER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter35highgamble",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35 - HIGH GAMBLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/35_chapter36ashowdownbetweenaswordsmanandaswordsman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36 - A SHOWDOWN BETWEEN A SWORDSMAN AND A SWORDSMAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter37achallengefromthemaster",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37 - A CHALLENGE FROM THE MASTER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter38thatresplendentswordlight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 38 - THAT RESPLENDENT SWORD LIGHT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter39teachertengsdiscovery",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 39 - TEACHER TENG'S DISCOVERY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter40yepingnansshock",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 40 - YE PINGNAN'S SHOCK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter41preliminaryconcocting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 41 - PRELIMINARY CONCOCTING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter42corecondensation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 42 - CORE CONDENSATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter43originbreakingmastercongealingpearl",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 43 - ORIGIN BREAKING MASTER CONGEALING PEARL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter44secondsealoftheqianyuansword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 44 - SECOND SEAL OF THE QIAN YUAN SWORD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter45parenthesis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 45 - PARENTHESIS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter46cooperationwiththecolosseum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 46 - COOPERATION WITH THE COLOSSEUM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter47eldertongsexclamations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 47 - ELDER TONG'S EXCLAMATIONS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter48levelofinterestinthecolosseum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 48 - LEVEL OF INTEREST IN THE COLOSSEUM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter49thebighandofthecolosseum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 49 - THE BIG HAND OF THE COLOSSEUM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter50readytotreatmother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 50 - READY TO TREAT MOTHER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter51mothersawakening",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 51 - MOTHERS' AWAKENING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter52iyexiaoamsomeonewhohasamotherwholoveshim",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 52 - I YE XIAO AM SOMEONE WHO HAS A MOTHER WHO LOVES HIM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter53preparationsbeforeleavinghome",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 53 - PREPARATIONS BEFORE LEAVING HOME")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter54tothegateofheavenlysecrets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 54 - TO THE GATE OF HEAVENLY SECRETS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter55qingpingcity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 55 - QINGPING CITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter56qingpingshan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 56 - QING PING SHAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter57thepowerbehindtheroyalfamilyinthenightcity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 57 - THE POWER BEHIND THE ROYAL FAMILY IN THE NIGHT CITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter58encounteredbyarobbery",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 58 - ENCOUNTERED BY A ROBBERY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter59thepowerofthetenthousandswordstechnique",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 59 - THE POWER OF THE TEN THOUSAND SWORDS TECHNIQUE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter60falloffacliff",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 60 - FALL OFF A CLIFF")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/60_chapter61caveskeleton",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 61 - CAVE SKELETON")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter6210000yearspiritmilk",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 62 - 10000 YEAR SPIRIT MILK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/62_chapter63masterlevel4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 63 - MASTER LEVEL 4")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/63_chapter64cisternae",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 64 - CISTERNAE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/64_chapter65chicken",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 65 - CHICKEN?")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/65_chapter66igotcaughtupinit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 66 - I GOT CAUGHT UP IN IT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/66_chapter67stupidbean",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 67 - STUPID BEAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter68mountainofdestinymountaingate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 68 - MOUNTAIN OF DESTINY MOUNTAIN GATE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/68_chapter69danyuanpeakdisciple",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 69 - DANYUAN PEAK DISCIPLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter70iwillbullyyou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 70 - I WILL BULLY YOU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/70_chapter71forcedintrusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 71 - FORCED INTRUSION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/71_chapter72danyuanpeak",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 72 - DANYUAN PEAK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/72_chapter73reversingrightandwrong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 73 - REVERSING RIGHT AND WRONG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/73_chapter74iwillpunishyouwithtenyearsofmenialwork",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 74 - I WILL PUNISH YOU WITH TEN YEARS OF MENIAL WORK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/74_chapter75flattenthedanyuanpeak",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 75 - FLATTEN THE DANYUAN PEAK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/75_chapter76goodbyemaster",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 76 - GOODBYE MASTER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/76_chapter77thisistoomuch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 77 - THIS IS TOO MUCH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/77_chapter78an800yearoldunblossomedradianceemittedbytheheavenssecretdisc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 78 - AN 800 YEAR OLD UNBLOSSOMED RADIANCE EMITTED BY THE HEAVEN'S SECRET DISC")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/78_chapter79sectleaderappears",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 79 - SECT LEADER APPEARS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/79_chapter80greetingsgrandelder",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 80 - GREETINGS GRAND ELDER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/80_chapter81gradefivelifepill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 81 - GRADE FIVE LIFE PILL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/81_chapter82radixginsengsanguisorba",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 82 - RADIX GINSENG SANGUISORBA")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/82_chapter83elementalenergycompatibility",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 83 - ELEMENTAL ENERGY COMPATIBILITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/83_chapter84weirdtestresults",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 84 - WEIRD TEST RESULTS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/84_chapter85heavendefyingcompatibility",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 85 - HEAVEN-DEFYING COMPATIBILITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/85_chapter86breakthroughlevel5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 86 - BREAKTHROUGH LEVEL 5")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/86_chapter87merakpeak",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 87 - MERAK PEAK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/87_chapter88eldestbrother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 88 - ELDEST BROTHER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/88_chapter89darksurge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 89 - DARK SURGE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/89_chapter90bookpavilion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 90 - BOOK PAVILION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/90_chapter91theshadowemperorwasshocked",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 91 - THE SHADOW EMPEROR WAS SHOCKED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/91_chapter92thetwomonarchswereabouttocollide",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 92 - THE TWO MONARCHS WERE ABOUT TO COLLIDE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/92_chapter93snatchanapprentice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 93 - SNATCH AN APPRENTICE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/93_chapter94thetwodumbfoundedmonarchs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 94 - THE TWO DUMBFOUNDED MONARCHS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/94_chapter95merakpeakwillloseface",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 95 - MERAK PEAK WILL LOSE FACE?")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/95_chapter96onemove",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 96 - ONE MOVE!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/96_chapter97youletsgotogether",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 97 - YOU 'LET'S GO TOGETHER!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/97_chapter98smallsuccessofthethousandshadowconcept",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 98 - SMALL SUCCESS OF THE THOUSAND SHADOW CONCEPT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/98_chapter99humanrankinggutian",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 99 - HUMAN RANKING GU TIAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/99_chapter100thepoweroftheonelineheaven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 100 - THE POWER OF THE ONE LINE HEAVEN")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0